export const environment = {
  production: true,
  apiBeta82: '/api-beta82',
  apiBeta822: '/api-beta822',
  apiV2: '/api-v2',
  apiNg: '/api-ng',
  apiBeta74: '/api-beta74',
  apiDev1: '/api-dev1',
  bannersList: '/api/list-banners',
  countApi: '/api/cars-count',
  filterApi: '/api/filter-data',
  landingpageApi: '/api/landingpage',
  cachedLandingpageApi: '/api/cache-landingpage',
  recommenderApi: '/api/recommender',
  newCarsRecommenderApi: '/api/recommender-new-cars',
  comingSoonRecommenderApi: '/api/recommender-coming-soon',
  carsApi: '/api/cars',
  productsApi: '/api/products',
  accessoriesList: '/api/accessories',
  strapiLandingpageApi: '/api/strapi-landingpage?page=',
  strapiNavigationApi: '/api/navigation',
  iconsApi: '/api/icons',
  strapiPartnersApi: '/api/partners',
};
